import colors from "../colors.js";

export default colors("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");



//////////////////
// WEBPACK FOOTER
// /srv/http/murdocktrust.org/releases/458/web/app/themes/murdock-serenity/node_modules/d3-scale-chromatic/src/categorical/Pastel1.js
// module id = 677
// module chunks = 0